// Module
var code = "<!--postponed for complex customers:\n<h2 class=\"<tpl if='is_invoice || is_registered'>badged</tpl>\">{name}</h2>-->\n<tpl if=\"postcode || city || address1 || address2\">\n    <div class=\"address\">\n        <p>{postcode} {city}</p>\n        <p>{address1}</p>\n        <p>{address2}</p>\n    </div>\n</tpl>\n";
// Exports
module.exports = code;